import set from "@rill/set";
import _ from "lodash";
import moment from "moment";
import ActivityDrawer from "../../../../parts/activity-drawer/ActivityDrawer";
import MealPhotos from "./MealPhotos";

function getPhotoThreadMapForDay(day) {
  const photoThreadMap = [];
  const mealPhotos = day?.mealPhotos || {};
  Object.values(mealPhotos).forEach((mealData) => {
    if (mealData?.list) {
      mealData.list.forEach((photo) => {
        const threadId = photo.threadId || photo.thread?._id;
        if (photo._id && threadId) {
          photoThreadMap.push({ photoId: photo._id, threadId });
        }
      });
    }
  });
  return photoThreadMap;
}

const MealPhotosController = (app) => {
  app.get(
    "/meal-photos",
    set("heading", "Meal Photos"),
    async ({ locals, res, req, load }) => {
      const { query } = req;
      const { startDate, endDate } = query;
      const startDateValue =
        startDate || Number(moment().startOf("month").format("YYYYMMDD"));
      const endDateValue =
        endDate || Number(moment().endOf("month").format("YYYYMMDD"));

      const mealPhotos = await load("mealPhotos", {
        ...query,
        startDate: startDateValue,
        endDate: endDateValue,
      });

      const dailyStatId = query.dailyStatId;
      if (dailyStatId && mealPhotos?.days) {
        const day = mealPhotos.days.find((d) => d._id === dailyStatId);
        const photoThreadMap = day ? getPhotoThreadMapForDay(day) : [];
        if (photoThreadMap.length > 0) {
          await load("mealComments", { photoThreadMap });
        } else {
          delete locals.mealComments;
        }
      } else {
        delete locals.mealComments;
      }

      const modal = _.get(query, "modal", {});

      locals.modal = {
        "activity-feed": <ActivityDrawer />,
      }[modal.type];
      res.body = (
        <MealPhotos
          locals={locals}
          mealPhotos={mealPhotos}
          startDate={startDateValue}
          endDate={endDateValue}
        />
      );
    }
  );
};

export default MealPhotosController;
